import Banner from 'components/Banner/Banner'
import { SectionTitle } from 'components/Sections/SectionTitle'
import SectionWrapper from 'components/Wrapper/SectionWrapper'
import { imgUrls } from 'constants/imgUrls'
import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'

const Products = () => {

    return (
        <>
            <Banner imgUrl={imgUrls.aboutUsBanner} />
            <SectionWrapper>
                <SectionTitle title="Our Products"></SectionTitle>
                <Container>
                    <Row>
                        <Col md={6} className="pb-4">
                            <Image src={imgUrls.productsImg1} width="100%" />
                        </Col>
                        <Col md={6} className="pb-4">
                            <Image src={imgUrls.productsImg2} width="100%" />
                        </Col>
                        <Col md={6} className="pb-4">
                            <Image src={imgUrls.productsImg3} width="100%" />
                        </Col>
                        <Col md={6} className="pb-4">
                            <Image src={imgUrls.productsImg4} width="100%" />
                        </Col>
                        <Col md={6} className="pb-4">
                            <Image src={imgUrls.productsImg5} width="100%" />
                        </Col>
                        <Col md={6} className="pb-4">
                            <Image src={imgUrls.productsImg6} width="100%" />
                        </Col>
                    </Row>
                </Container>
            </SectionWrapper>
        </>
    )
}

export default Products;